// Contracts — javelin: заведение модератора из Telegram-бота.
//
// Воркер: apps/api/src/javelin/ops.ts (+ provision.ts — сама работа).
// Клиент: apps/tgbot/src/javelin.ts (бот @weernaibot).
//
// Гейт у этих ручек собственный (общий секрет бота + список операторов в
// javelin_ops_operators), поэтому «кто просит» едет полем tg_user_id: у
// машины нет и не может быть Firebase-токена человека.
import { z } from 'zod';
import { MOD_ROLE_STATE, MOD_SHEET_STATE } from '../vocab/javelin';

export const JavOpsProvisionReqSchema = z.object({
  tg_user_id: z.string().min(1),
  display_name: z.string().min(1).max(40),
  email: z.string().min(3).max(160),
  /** Пусто → ставка по умолчанию из javelin_settings. */
  rate_usd: z.number().positive().max(500).optional(),
});
export type JavOpsProvisionReq = z.infer<typeof JavOpsProvisionReqSchema>;

export const JavOpsProvisionResSchema = z.object({
  ok: z.boolean(),
  /** true — по этой почте модератор уже был, ничего не меняли. */
  already: z.boolean(),
  mod_id: z.string(),
  display_name: z.string(),
  email: z.string(),
  rate_usd: z.number(),
  manager_mod_ids: z.array(z.string()),
  iteration: z.string(),
  role_state: z.enum(MOD_ROLE_STATE),
  sheet_tab: z.string(),
  sheet_state: z.enum(MOD_SHEET_STATE),
  sheet_error: z.string().default(''),
  warnings: z.array(z.string()).default([]),
});
export type JavOpsProvisionRes = z.infer<typeof JavOpsProvisionResSchema>;

export const JavOpsOperatorSchema = z.object({
  tg_user_id: z.string(),
  label: z.string().default(''),
  can_add_moderator: z.boolean(),
  active: z.boolean(),
});
export type JavOpsOperator = z.infer<typeof JavOpsOperatorSchema>;

export const JavOpsOperatorsResSchema = z.object({
  operators: z.array(JavOpsOperatorSchema),
});
export type JavOpsOperatorsRes = z.infer<typeof JavOpsOperatorsResSchema>;

export const JavOpsOperatorSetReqSchema = z.object({
  /** Правит список только владелец — сверяется с WEERN_TG_NOTIFY_CHAT_ID. */
  actor_tg_user_id: z.string().min(1),
  tg_user_id: z.string().regex(/^-?\d+$/),
  label: z.string().max(80).default(''),
  active: z.boolean().default(true),
});
export type JavOpsOperatorSetReq = z.infer<typeof JavOpsOperatorSetReqSchema>;

export const JavOpsOperatorSetResSchema = z.object({
  ok: z.boolean(),
  tg_user_id: z.string(),
  label: z.string().default(''),
  active: z.boolean(),
});
export type JavOpsOperatorSetRes = z.infer<typeof JavOpsOperatorSetResSchema>;
